import React, { useEffect, useState } from "react";
import "./themecoll.css";
import Navbar from "../helpers/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../redux/reducers/profileSlice";
import { snackbarContext } from "../helpers/Snakbar";
import { useNavigate } from "react-router-dom";
import { clearError, clearUser } from "../../redux/reducers/authSlice";
import { TabTitle } from "../helpers/GeneralFunctions";

const themes = [
  {
    id: 1,
    themeId: "theme1",
    userId: "ftj9rlyw8",
    name: "Sage Bloom",
    image: "https://res.cloudinary.com/depixc8dq/image/upload/v1791262142/aamantran%20assets/theme1-card-cover_anza8t.png",
    category: "floral",
    badge: "New",
    description:
      "A graceful floral design combining muted sage tones with delicate blooms for a soft,romantic invitation",
  },

  {
    id: 2,
    themeId: "theme2",
    userId: "qpqhzrdqb",
    name: "Dusty Rose",
    image: "https://res.cloudinary.com/depixc8dq/image/upload/v1791262142/aamantran%20assets/theme2-card-cover_fhkqbp.png",
    category: "minimal",
    badge: "Trending",
    description:
      "A soft design with muted rose tones, delicate details, and timeless romantic charm",
  },

  {
    id: 3,
    themeId: "theme3",
    userId: "dsfdkfzri",
    name: "Royal Motif",
    image: "https://res.cloudinary.com/depixc8dq/image/upload/v1791262142/aamantran%20assets/theme3-card-cover_z6ndie.png",
    category: "pattern",
    badge: "New",
    description:
      "A rich traditional design featuring intricate ornamental patterns, and warm earthy tones",
  },

    {
    id: 4,
    themeId: "theme4",
    userId: "j4j8c3alk",
    name: "Maroon Majesty",
    image: "https://res.cloudinary.com/depixc8dq/image/upload/v1791262141/aamantran%20assets/theme4-card-cover_viffh2.png",
    category: "dark",
    badge: "New",
    description:
      "A rich and elegant design featuring deep maroon tones and a luxurious traditional charm.",
  },

   {
    id: 5,
    themeId: "theme5",
    userId: "zuxkcmp5w",
    name: "Ruby Garden",
    image: "https://res.cloudinary.com/depixc8dq/image/upload/v1789361178/aamantran%20assets/ELEGANT_FLORAL_2_sfbsjj.png",
    category: "floral",
    badge: "New",
    description:
      "A bold floral design combining deep crimson tones with graceful botanical details",
  },

];



const filters = [
  {
    id: "all",
    label: "All",
  },
  {
    id: "floral",
    label: "Floral",
  },
  {
    id: "minimal",
    label: "Minimal",
  },
  {
    id: "pattern",
    label: "Pattern",
  },
  {
    id: "dark",
    label: "Dark",
  },
];


const getCloudinaryWidthUrl = (url, width) => {
  if (!url) return "";
  return url.replace("/upload/", `/upload/w_${width}/`);
};

const ThemeCollection = () => {
  TabTitle("Themes")
   const {user,error:backendError} = useSelector(state => state.auth);
   const { weddingData: profileData} = useSelector((state) => state.profile)
    const setStateSnackbarContext=React.useContext(snackbarContext)
    const navigate=useNavigate()
  const [activeFilter, setActiveFilter] = useState("all");
   const dispatch=useDispatch()


     // DB: "theme2"
  // Local ID: 2
  const selectedThemeId = profileData?.theme
    ? Number(profileData.theme.replace("theme", ""))
    : null;

  const selectedTheme = themes.find(
    (theme) => theme.id === selectedThemeId
  );

  const otherThemes = themes.filter(
    (theme) => theme.id !== selectedThemeId
  );

  const filteredThemes =
    activeFilter === "all"
      ? otherThemes
      : otherThemes.filter(
          (theme) => theme.category === activeFilter
        );


  // const handleEditTheme = (theme) => {
  //   console.log("Edit theme:", theme);
  // };


  const handleSelectTheme = (theme) => {
     navigate(`/demo/${theme.userId}?theme=${theme.themeId}`);
  };

     useEffect(() => {
          dispatch(getProfile())
          window.scrollTo(0, 0);
      }, [])

       useEffect(()=>{
          if (backendError === "session expired" || backendError==="pls login to acess the resource") {
              setStateSnackbarContext(true, "session expired please login again", "error");
              dispatch(clearError())
              dispatch(clearUser())
              navigate("/login")
          }else if (backendError) {
              setStateSnackbarContext(true, backendError, "error");
              dispatch(clearError());
            }
      },[backendError])

  return (
    <>
      <Navbar />

      <main
  className={`theme-collection ${
    user?.demoVersion ? "collection-extra-padding" : ""
  }`}
>
        {/* =========================
            SELECTED THEME
        ========================= */}

        <section className="selected-theme-section">
 
        {selectedTheme &&  <h1 className="theme-collection-heading">
            Your Selected Theme
          </h1>}  

          {selectedTheme && (
            <div className="theme-card theme-card-selected">

              <div className="theme-card-preview">

              <img
  src={getCloudinaryWidthUrl(selectedTheme.image, 640)}
  srcSet={`
    ${getCloudinaryWidthUrl(selectedTheme.image, 320)} 320w,
    ${getCloudinaryWidthUrl(selectedTheme.image, 640)} 640w
  `}
  sizes="(max-width: 768px) 90vw, 640px"
  alt={`${selectedTheme.name} theme`}
  className="theme-preview-image"
/>

                <span className="theme-card-badge selected-theme-badge">
                  Your Selected Theme
                </span>

              </div>

              <div className="theme-card-content selected-theme-content">

                <h2 className="theme-card-name">
                  {selectedTheme.name}
                </h2>

                <button
                  className="theme-card-button selected-theme-button"
                  onClick={() => navigate("/details")}
                >
                  Edit 
                </button>

              </div>

            </div>
          )}

        </section>


        {/* =========================
            OTHER THEMES
        ========================= */}

        <section className="other-themes-section">

          <h2 className="other-themes-heading">
           {selectedTheme ? "Explore Other Themes" :"Explore Themes" } 
          </h2>


          {/* =========================
              STYLE FILTER
          ========================= */}

          <div className="theme-filter-wrapper">

            <p className="theme-filter-label">
              Browse by Style
            </p>

            <div className="theme-filters">

              {filters.map((filter) => (
                <button
                  key={filter.id}
                  className={`theme-filter ${
                    activeFilter === filter.id
                      ? "active"
                      : ""
                  }`}
                  onClick={() =>
                    setActiveFilter(filter.id)
                  }
                >
                  {filter.label}
                </button>
              ))}

            </div>

          </div>


          {/* =========================
              THEME CARDS
          ========================= */}

          <div className="theme-cards">

            {filteredThemes.length > 0 ? (

              filteredThemes.map((theme) => (
                <div
                  className="theme-card"
                  key={theme.id}
                >

                  <div className="theme-card-preview">

                    <img
  src={getCloudinaryWidthUrl(theme.image, 640)}
  srcSet={`
    ${getCloudinaryWidthUrl(theme.image, 320)} 320w,
    ${getCloudinaryWidthUrl(theme.image, 640)} 640w
  `}
  sizes="(max-width: 768px) 90vw, 640px"
  alt={`${theme.name} theme`}
  className="theme-preview-image"
/>

                    {theme.badge && (
                      <span className="theme-card-badge">
                        {theme.badge}
                      </span>
                    )}

                  </div>


                  <div className="theme-card-content">

                    <h2 className="theme-card-name">
                      {theme.name}
                    </h2>

                    <p className="theme-card-description">
                      {theme.description}
                    </p>

                    <button
                      className="theme-card-button"
                      onClick={() =>
                        handleSelectTheme(theme)
                      }
                    >
                      Use This Theme
                    </button>

                  </div>

                </div>
              ))

            ) : (

              <p className="no-themes-message">
                No other themes available in this style.
              </p>

            )}

          </div>

        </section>

      </main>
    </>
  );
};

export default ThemeCollection;